import React from 'react';
import axios from 'axios';
import strings from '../../../components/Language';
import { api } from '../../../components/config/api';
import { getToken } from '../../../components/Util';
import './hero.scss';

// Home balance hero: USDT balance, today's trading profit and the Auto Trade
// status. Each value loads on its own, so one failing call doesn't hide the rest.
class HomeHero extends React.Component {
    constructor(props) {
        super(props);
        this.state = { balance: null, today: null, running: false };
    }

    async componentDidMount() {
        const token = await getToken();
        if (!token) return;
        const headers = {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept-Language': strings.getLanguage(),
        };
        const get = (url) => axios({ method: 'GET', url, headers }).then((r) => r.data).catch(() => null);

        get(api.balance).then((d) => {
            if (d && d.error === 200 && d.data) this.setState({ balance: Number(d.data.balance) || 0 });
        });
        get(api.reward).then((d) => {
            const v = d && d.data && d.data.trading_profit ? d.data.trading_profit.profit_today : null;
            if (v !== null && v !== undefined && !isNaN(Number(v))) this.setState({ today: Number(v) });
        });
        get(api.auto_trade).then((d) => {
            if (d && d.error === 200 && d.data) this.setState({ running: !!d.data.status });
        });
    }

    render() {
        const { balance, today, running } = this.state;
        return (
            <section className="a-hero" aria-label={strings.total_balance}>
                <div className="a-hero-top">
                    <span className="a-hero-label">{strings.total_balance}</span>
                    {running ?
                        <span className="a-live-pill"><span className="a-live-pill-dot" />{strings.auto_trade_on}</span>
                        : null}
                </div>
                <div className="a-hero-value">
                    {balance === null ? '--' : balance.toFixed(2)}
                    <span className="a-hero-unit">USDT</span>
                </div>
                {today !== null ?
                    <div className={'a-hero-sub ' + (today >= 0 ? 'up' : 'down')}>
                        {(today >= 0 ? '+' : '') + today.toFixed(4)} · {strings.Trading_Profit} {strings.today_word}
                    </div>
                    : null}
            </section>
        );
    }
}

export default HomeHero;
